import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    switchesContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    container: {
        alignItems: "center",
        flex: 1
    },
    paddedMarginContainer: {
        minHeight: 120
    },
    descText: {
        marginBottom: 20
    },
    marginContainer: {
        marginBottom: 20
    },
    contentContainer: {
        maxWidth: 850,
        width: "100%"
    }
});
export default stylesheet;
